/* @ngInject */
function CampaignDocumentController ($scope, $translate, CampaignService, UdsModalService, ToastService, $state, $location, $q, UserService, ConfirmationModalService, SegmentService) {
  const getChooseDocTemplateDialogController = () => $q.when(import('../../../repository/dialogs/choose-doc-template/choose-doc-template-dialog.controller'))

  $scope.documents = []
  $scope.flags = {
    loading: true,
    creating: false
  }

  $scope.emptyState = {
    imgPath: 'campaign-document',
    title: $translate.instant('campaignEdit.documents.emptyState.title'),
    message: $translate.instant('campaignEdit.documents.emptyState.message'),
    button: {
      icon: 'plus',
      type: 'primary',
      text: $translate.instant('campaignEdit.documents.emptyState.button'),
      click: () => api._createNewDocument(),
      loading: $scope.flags.creating,
      disabled: $scope.campaign.status === 'FINISHED',
      tooltip: {
        text: $translate.instant('campaignErrors.campaignFinished'),
        position: 'bottom',
        disabled: $scope.campaign.status !== 'FINISHED'
      }
    }
  }

  const api = {
    getChooseDocTemplateDialogController,
    _createNewDocument,
    _getDocuments,
    _deleteDocument
  }

  this.getApi = () => api
  activate()

  function activate () {
    api._getDocuments()
    $scope.goBackRoute = $location.path().replace(/^\//, '')
  }

  $scope.openUpdateDocument = (documentId) => {
    SegmentService.track('doc-edit', { doc_id: documentId, page: 'campaign' })
    $state.go('documents.editor', { id: documentId, goBackRoute: $scope.goBackRoute, readOnly: 'false' })
  }

  $scope.openReadDocument = (documentId) => {
    $state.go('documents.editor', { id: documentId, goBackRoute: $scope.goBackRoute, readOnly: 'true' })
  }

  $scope.openDeleteDocument = ($event, documentId) => {
    $event.stopPropagation()
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignEdit.documents.delete.title'),
      description: $translate.instant('campaignEdit.documents.delete.description'),
      buttonCancelText: $translate.instant('goBack'),
      buttonConfirmText: $translate.instant('campaignEdit.documents.delete.confirmText'),
      onConfirm: () => api._deleteDocument(documentId)
    })
  }

  $scope.createNewDocument = () => {
    api._createNewDocument()
  }

  $scope.getAvatarUrl = (user) => {
    return UserService.getUserProfileImage(user.id)
  }

  function _getDocuments () {
    $scope.flags.loading = true
    CampaignService.getDocuments({ campaignId: $scope.campaign.id }).then((res) => {
      $scope.documents = res
    }).catch(() => {
      ToastService.defaultErrorToast()
    }).finally(() => {
      $scope.flags.loading = false
    })
  }

  function _createNewDocument () {
    $scope.flags.creating = true
    return api.getChooseDocTemplateDialogController().then(({ ChooseDocTemplateDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: ChooseDocTemplateDialogController,
        modalName: 'chooseDocTemplateDialog',
        data: {
          location: 'campaigns',
          campaignId: $scope.campaign.id
        },
        onClose: () => {
          $scope.flags.creating = false
        }
      })

      modal.open()
    })
  }

  function _deleteDocument (documentId) {
    $scope.flags.deleting = true
    CampaignService.deleteDocument({ documentId, campaignId: $scope.campaign.id }).then(() => {
      ToastService.showSuccessToast($translate.instant('campaignEdit.documents.deleteSuccess'))
      api._getDocuments()
    }).catch(() => {
      ToastService.defaultErrorToast()
    }).finally(() => {
      $scope.flags.deleting = false
    })
  }
}

export { CampaignDocumentController }
